module.exports = __webpack_public_path__ + "static/media/teams-1.1090e9fc.jpg";